/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Login_ButtonInputs */

const en_home_login_button = /** @type {(inputs: Home_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const fr_home_login_button = /** @type {(inputs: Home_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const ms_sg2_home_login_button = /** @type {(inputs: Home_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Home_Login_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_login_button = /** @type {((inputs?: Home_Login_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Login_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_login_button(inputs)
	if (locale === "fr") return fr_home_login_button(inputs)
	return ms_sg2_home_login_button(inputs)
});